export const BRANCH_NOT_FOUND = 'branch-not-found';

export const COMPANY_NOT_FOUND_FIELD = {
  value: 'uid-not-found',
  label: 'company.noCompany',
  company: 'uid-not-found',
  uid: 'uid-not-found',
};

export const SALUTATION_OPTIONS = [
  {
    label: 'salutation.values.male',
    value: 'male',
  },
  {
    label: 'salutation.values.female',
    value: 'female',
  },
];

export const FUNCTION_OPTIONS = [
  {
    label: 'function.values.electrician',
    value: 'electrician',
  },
  {
    label: 'function.values.switch-gear-manufacturer',
    value: 'switch-gear-manufacturer',
  },
  {
    label: 'function.values.integrator',
    value: 'integrator',
  },
  {
    label: 'function.values.wholesale-distribution',
    value: 'wholesale-distribution',
  },
  {
    label: 'function.values.electrical-planner',
    value: 'electrical-planner',
  },
  {
    label: 'function.values.architect',
    value: 'architect',
  },
  {
    label: 'function.values.apprentices',
    value: 'apprentices',
  },
  {
    label: 'function.values.other',
    value: 'other',
  },
];
